import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import blogPosts from '../data/blogPosts'

function formatDate(dateStr) {
  return new Date(dateStr + 'T12:00:00').toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

const categoryColors = {
  Tendências: 'bg-blue-50 text-blue-700',
  Gestão: 'bg-green-50 text-green-700',
  Operações: 'bg-orange-50 text-orange-700',
  Tutorial: 'bg-purple-50 text-purple-700',
}

export default function Blog() {
  return (
    <div className="min-h-screen bg-white text-black">
      <SEO
        title="Blog"
        description="Dicas, tutoriais e tendências para restaurantes que querem crescer com tecnologia. Cardápio digital, delivery, gestão de mesas e mais."
        path="/blog"
      />
      <nav className="sticky top-0 z-50 bg-white/97 backdrop-blur-md border-b border-neutral-200">
        <div className="flex items-center justify-between px-5 py-4 md:px-10 lg:px-16">
          <Link to="/" className="no-underline">
            <img src="/waitherelogo.png" alt="Waithere" className="h-7 w-auto" />
          </Link>
          <Link
            to="/"
            className="text-sm text-neutral-500 no-underline hover:text-black transition-colors"
          >
            ← Voltar ao início
          </Link>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-5 py-16 sm:px-8 lg:px-0">
        <h1 className="text-3xl sm:text-4xl font-bold mb-3">Blog</h1>
        <p className="text-neutral-500 text-lg mb-12">
          Dicas, tutoriais e tendências para restaurantes que querem crescer com tecnologia.
        </p>

        <div className="grid gap-8">
          {blogPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="group block no-underline border border-neutral-200 rounded-2xl p-6 sm:p-8 hover:border-neutral-400 transition-colors"
            >
              <div className="flex flex-wrap items-center gap-3 mb-3">
                <span
                  className={`text-xs font-medium px-2.5 py-1 rounded-full ${
                    categoryColors[post.category] || 'bg-neutral-100 text-neutral-600'
                  }`}
                >
                  {post.category}
                </span>
                <span className="text-xs text-neutral-400">
                  {formatDate(post.date)} · {post.readTime} de leitura
                </span>
              </div>
              <h2 className="text-xl sm:text-2xl font-semibold text-black group-hover:text-neutral-700 transition-colors mb-2">
                {post.title}
              </h2>
              <p className="text-neutral-500 text-[15px] leading-relaxed">{post.excerpt}</p>
            </Link>
          ))}
        </div>
      </main>
    </div>
  )
}
